import { useEffect, useRef, useState } from "react";
import { useQuery } from "react-apollo";

import nanoid from "nanoid";

import { useStore } from "../providers/AppProvider";
import { SETTING_SEASON_YEAR } from "../utils/settings";

import { GET_DATA_SOURCES2 } from "../../../queries";

import { GetDataSource_syncarto_app_data_source } from "../../../__generated__/types";
import { DataSourceLayerMeta, DataSourceRasterLayer, DataSourceRasterLayerExtended} from "../types/types";
import { getTileUrlTemplate } from "../utils/dataSourceUtils";

import ESRI_SATELLITE from '../components/Map/styles/esri-satellite.json';
import { MAPBOX_SATELLITE } from '../components/Map/styles/mapbox-satellite';
import ESRI_BASE_LABELS from '../components/Map/styles/esri-labels.json';

export const useRasterDataSources = (config: DataSourceLayerMeta[]) => {
    const {settings} = useStore();

    const [dataSources, setDataSources] = useState<DataSourceRasterLayer[]>([]);
    const [year, setYear] = useState<string|null>(null);

    const {data, loading} = useQuery(GET_DATA_SOURCES2, { fetchPolicy: "no-cache" });

    const tsRef = useRef<string | null>(null);

    useEffect(() => {
        setYear(settings[SETTING_SEASON_YEAR]);
    },[settings[SETTING_SEASON_YEAR]]);

    useEffect(() => {
        console.log("012524 useRasterDataSources", settings)
        console.log("012524 useRasterDataSources", loading)
        console.log("012524 useRasterDataSources", data)
        if(!loading && data) { 
            let settingsTs = null;
            if('indices_date' in settings) {
                const obj = JSON.parse(settings['indices_date']);
                settingsTs = obj.end_date;
            }
            console.log("012524 useRasterDataSources tsRef.current", tsRef.current)
            console.log("012524 useRasterDataSources settingsTs", settingsTs)
            if(tsRef.current !== settingsTs) {
                tsRef.current = settingsTs;
            } else {
                if(!tsRef.current && !settingsTs) {
                    // if these are both null then the timeline probably wasnt engaged yet
                }else{
                    if(dataSources.length) {
                        console.log("012524 useRasterDataSources returning")
                        return;
                    }
                }
            }

            // 
            console.log("012524 config", config)
            const sourceIds = config.map((c: DataSourceLayerMeta) => c.id);
            console.log("012524 sourceIds", sourceIds)
            console.log("012524 data", data)
            const sources = data.syncarto_app_data_source.filter((source: GetDataSource_syncarto_app_data_source) => {
                // Add additional matching condition for UAS Imagery (nominally on Olam) which has a different collection_id suffix (-rgb instead of -rgbn)
                return (sourceIds.includes(source.collection_id!) || (sourceIds.includes(source.collection_id!.replace("-rgb","-rgbn")) && source.title === "High Res. Normal Color"))
                //return sourceIds.includes(source.collection_id!) 
            });
            console.log("012524 sources", sources)
            sources.push(ESRI_BASE_LABELS);
            sources.push(MAPBOX_SATELLITE);
            const layers: DataSourceRasterLayer[] = sources.map((source: DataSourceRasterLayerExtended) => {
                console.log("062723 source", source)
                const dataSourceMetaFiltered = config.filter(s => {
                    if (s.name === "UAS Imagery"){
                        //return (s.id === source.collection_id && source.title === "High Res. Normal Color");
                        return (source.title === "High Res. Normal Color");
                    }else{
                        return s.id === source.collection_id;
                    }
                });
                let dataSourceMeta = dataSourceMetaFiltered[0];
                if (dataSourceMetaFiltered.length > 1){
                    const dataSourceMetaFind = dataSourceMetaFiltered.find(s => {
                        return s.disambiguate === source.title;
                    });
                    if (dataSourceMetaFind){ dataSourceMeta = dataSourceMetaFind };
                } 
                let _uuid = nanoid(8);               
                /*if (source.collection_id === 'NAIP'){
                    _uuid = "NAIP_678" // Use an arbitrary but consistent uuid here in order to get react to NOT re-render NAIP aerial upon date update.
                }*/
                if (source.collection_id === 'ESRI'){
                    _uuid = "ESRI_678" // Use an arbitrary but consistent uuid here in order to get react to NOT re-render ESRI satellite upon date update.
                }
                if (source.collection_id === 'ESRI_LABELS'){
                    _uuid = "ESRI_LABELS_678" // Use an arbitrary but consistent uuid here in order to get react to NOT re-render ESRI satellite upon date update.
                }
                if (dataSourceMeta?.date && year){
                    dataSourceMeta.date = year;
                }
                const dataSourceLayer: DataSourceRasterLayer = {
                    name: dataSourceMeta?.name ?? source.title,
                    id: source.collection_id!,
                    uuid: _uuid,
                    min_zoom: dataSourceMeta ? dataSourceMeta.minZoom : 0,
                    max_zoom: dataSourceMeta ? dataSourceMeta.maxZoom : 24,
                    is_visible: dataSourceMeta?.visible!,
                    type: dataSourceMeta?.type!,
                    order: dataSourceMeta?.order!,
                    display: dataSourceMeta?.display,
                    tiles: source.stac_address 
                        ? getTileUrlTemplate(
                            source,
                            source.stac_address!, 
                            source.collection_id!,
                            'footprint_id',
                            dataSourceMeta?.date ? `${year}-01-01` : source.min_date,
                            dataSourceMeta?.date ? `${year}-12-31` : (tsRef.current ? tsRef.current : source.max_date),
                            source.date_display_resolution!,
                            dataSourceMeta?.date ? "template" : "template-singledate-p1",
                            null,
                            "global",
                            settings.season_year
                        ) 
                        : source.tile_urls,
                    source: {...source},
                    dataSourceMeta: dataSourceMeta
                };

                return dataSourceLayer;
                
            });
            setDataSources(layers);
        }
    }, [loading, settings]);

    return { dataSources, loading };
}